// require("dotenv").config()

export default process.env



// WEBPACK FOOTER //
// ./src/config.js